export default {"src":"/_next/static/media/fashion.6703410d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};